import auth from '../services/auth';
import { getRecaptcha } from '../services/recaptcha';
import routes from '../constants/routes';
import routing from '../services/routing';

export default async (data: { username: string }) => {
    const { username } = data;
    const token = await getRecaptcha().execute();
    await auth.forgotPassword({
        recaptcha: true,
        token,
        username,
    });
    const encodedUsername = encodeURIComponent(username);
    getRecaptcha().unmount();
    routing.push(routes.CONFIRM_FORGOT_PASSWORD, { username: encodedUsername });
};
